/* Box grossesse 49 et demi — comportements partagés.
   Idempotent : chaque section peut charger ce fichier sans effet de bord. */
(function () {
  'use strict';
  if (window.__bgdInit) return;
  window.__bgdInit = true;
  var d = document;

  function ready(fn) {
    if (d.readyState !== 'loading') fn();
    else d.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    d.querySelectorAll('.bgd-root').forEach(function (r) { r.classList.add('bgd-js'); });

    /* apparitions : balayage géométrique, un bloc déjà dépassé reste visible */
    var pending = [].slice.call(d.querySelectorAll('[data-reveal]'));
    /* apparition en cascade : chaque frere part 70 ms apres le precedent,
       plafonne a 6 pour qu une longue grille ne finisse pas en fondu interminable */
    pending.forEach(function (el) {
      var p = el.parentNode;
      if (!p || !p.querySelectorAll) return;
      var sibs = p.querySelectorAll(':scope > [data-reveal]');
      if (sibs.length < 2) return;
      var i = [].indexOf.call(sibs, el);
      if (i > 0) el.style.setProperty('--r-i', Math.min(i, 6));
    });
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      pending.forEach(function (el) { el.classList.add('is-in'); });
      pending = [];
    }
    function revealPass() {
      for (var i = pending.length - 1; i >= 0; i--) {
        if (pending[i].getBoundingClientRect().top < window.innerHeight * 0.92) {
          pending[i].classList.add('is-in');
          pending.splice(i, 1);
        }
      }
    }
    revealPass();
    window.addEventListener('scroll', function () { if (pending.length) revealPass(); }, { passive: true });

    /* rails horizontaux : photos clientes et carrousel d'avis */
    d.querySelectorAll('[data-bgd-rail]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-bgd-track]')
        || (wrap.closest('section') && wrap.closest('section').querySelector('[data-bgd-track]'));
      var prev = wrap.querySelector('[data-bgd-prev]');
      var next = wrap.querySelector('[data-bgd-next]');
      var count = wrap.querySelector('[data-bgd-count]');
      if (!track) return;
      var items = track.children;
      var perPage = wrap.hasAttribute('data-bgd-page') ;
      function step() {
        if (perPage) return track.clientWidth;
        var c = items[0];
        return c ? c.getBoundingClientRect().width + 18 : 300;
      }
      function state() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        if (count) {
          var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
          count.textContent = (i + 1) + ' / ' + items.length;
        }
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * (perPage ? 1 : 2), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * (perPage ? 1 : 2), behavior: 'smooth' }); });

      /* glisser a la souris : le tactile est deja gere nativement par le
         debordement horizontal, mais pas la souris. */
      var down = false, startX = 0, startLeft = 0, moved = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        down = true; moved = 0;
        startX = e.clientX; startLeft = track.scrollLeft;
        try { track.setPointerCapture(e.pointerId); } catch (x) {}
        track.classList.add('is-grabbing');
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > moved) moved = Math.abs(dx);
        track.scrollLeft = startLeft - dx;
      });
      function release(e) {
        if (!down) return;
        down = false;
        track.classList.remove('is-grabbing');
        try { track.releasePointerCapture(e.pointerId); } catch (x) {}
      }
      track.addEventListener('pointerup', release);
      track.addEventListener('pointercancel', release);
      track.addEventListener('pointerleave', release);
      /* pas d'image fantome quand on tire */
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      track.addEventListener('scroll', state, { passive: true });
      window.addEventListener('resize', state, { passive: true });
      /* les images peuvent arriver apres : on recalcule l'etat des fleches */
      window.addEventListener('load', state, { once: true });
      state();
    });

    /* FAQ : un seul volet ouvert a la fois, avec animation de hauteur.
       Sans JS le <details> natif continue de fonctionner. */
    d.querySelectorAll('.faq-list').forEach(function (list) {
      var items = [].slice.call(list.querySelectorAll('details'));
      var DUREE = 300;
      function corps(det) { return det.querySelector('.faq-body'); }
      /* Fermeture instantanee : c est ce que voit l utilisateur quand il ouvre
         une autre question, et ca ne depend d aucune animation. */
      function fermerNet(det) {
        var b = corps(det);
        if (det._t) { clearTimeout(det._t); det._t = null; }
        det.open = false;
        if (b) b.classList.remove('is-shut');
      }
      /* Fermeture animee, utilisee seulement quand on referme la question
         deja ouverte. Le minuteur conclut toujours, meme si le navigateur
         n interpole pas grid-template-rows (Firefox < 129). */
      function fermerDoux(det) {
        var b = corps(det); if (!b) { det.open = false; return; }
        if (det._t) clearTimeout(det._t);
        b.classList.add('is-shut');
        det._t = setTimeout(function () { det._t = null; fermerNet(det); }, DUREE);
      }
      function ouvrir(det) {
        var b = corps(det);
        if (det._t) { clearTimeout(det._t); det._t = null; }
        if (!b) { det.open = true; return; }
        det.open = true;
        b.classList.add('is-shut');
        b.offsetHeight;                /* force le recalcul avant de relacher */
        b.classList.remove('is-shut');
      }
      items.forEach(function (det) {
        var t = det.querySelector('summary');
        if (!t) return;
        t.addEventListener('click', function (e) {
          e.preventDefault();
          if (det.open && !det._t) { fermerDoux(det); return; }
          items.forEach(function (o) { if (o !== det) fermerNet(o); });
          ouvrir(det);
        });
      });    });

    /* Le JS du theme reecrit le libelle du bouton d ajout au panier a partir
       des traductions. On le repose depuis le reglage du bloc, et on le
       redonne apres chaque changement de variante. */
    d.querySelectorAll('[data-bgd-label]').forEach(function (btn) {
      var voulu = btn.getAttribute('data-bgd-label');
      if (!voulu) return;
      var cible = btn.querySelector('.t4s-btn-atc_text');
      if (!cible) return;
      function poser() { if (cible.textContent.trim() !== voulu) cible.textContent = voulu; }
      poser();
      new MutationObserver(poser).observe(cible, { childList: true, characterData: true, subtree: true });
    });

    /* Seal Subscriptions : nos pastilles « Votre mois de grossesse » pilotent
       le plan d abonnement. Le champ de l app est masque en CSS mais reste
       dans le formulaire : c est lui qui part au panier. Si l app n est pas
       installee, tout ceci ne fait rien. */
    (function () {
      var SEL_MOIS = '.t4s-line-item-property__field.is--type-radio input[type="radio"]';
      function champSeal() { return d.querySelector('.sealsubs-container select[name="subs_interval"]'); }
      function moisChoisi() {
        /* on relit le DOM a chaque fois : le theme reconstruit ce bloc
           a chaque changement de variante */
        var r = d.querySelector(SEL_MOIS + ':checked');
        return r ? String(r.value).trim() : null;
      }
      function synchro() {
        var sel = champSeal(), mois = moisChoisi();
        if (!sel || !mois) return;
        var chiffre = !isNaN(parseInt(mois, 10));
        var cible = null;
        for (var i = 0; i < sel.options.length; i++) {
          var t = sel.options[i].textContent.trim().toLowerCase();
          if (chiffre ? t.indexOf(mois + ' mois') === 0 : t.indexOf('post-partum') !== -1) { cible = sel.options[i]; break; }
        }
        /* aucune correspondance : on ne devine pas, on laisse l app tranquille */
        if (!cible) return;
        /* le champ peut deja afficher le bon mois alors que le plan n a jamais
           ete transmis (cas du 1er mois, valeur par defaut du menu) : dans ce
           cas on previent quand meme l app */
        var champPlan = d.querySelector('input[name="selling_plan"]');
        if (sel.value === cible.value && champPlan && champPlan.value) return;
        sel.value = cible.value;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      /* delegation sur le document : un ecouteur pose sur le bloc ne survit pas
         a sa reconstruction par le theme */
      d.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches(SEL_MOIS)) synchro();
      });
      /* l app se charge apres nous : on attend que son champ apparaisse */
      var essais = 0;
      var minuteur = setInterval(function () {
        if (champSeal() || ++essais > 40) { clearInterval(minuteur); synchro(); }
      }, 250);
    })();

    /* Avis de la colonne d achat : trois lignes, puis « Lire plus ».
       On mesure APRES le chargement des polices : avant, le texte n a pas sa
       hauteur definitive et on conclurait a tort qu il ne deborde pas. */
    function coupeAvis() {
      d.querySelectorAll('.bmr__t').forEach(function (p) {
        if (p.getAttribute('data-bgd-coupe')) return;
        p.classList.add('is--coupe');
        if (p.scrollHeight <= p.clientHeight + 2) { p.classList.remove('is--coupe'); return; }
        p.setAttribute('data-bgd-coupe', '1');
        var b = d.createElement('button');
        b.type = 'button';
        b.className = 'bmr__plus';
        b.textContent = 'Lire plus';
        b.addEventListener('click', function () {
          var etaitCoupe = p.classList.contains('is--coupe');
          p.classList.toggle('is--coupe', !etaitCoupe);
          b.textContent = etaitCoupe ? 'Réduire' : 'Lire plus';
        });
        p.parentNode.insertBefore(b, p.nextSibling);
      });
    }
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(coupeAvis); else coupeAvis();
    window.addEventListener('load', coupeAvis);

    /* avis Loox : bouton « voir plus » */
    d.querySelectorAll('[data-lox-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var grid = d.getElementById(btn.getAttribute('data-lox-more'));
        if (!grid) return;
        var caches = grid.querySelectorAll('[data-lox-extra]');
        for (var i = 0; i < caches.length; i++) {
          caches[i].removeAttribute('hidden');
          caches[i].removeAttribute('data-lox-extra');
        }
        btn.parentNode.removeChild(btn);
      });
    });
  });
})();
